import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, ReplaySubject } from 'rxjs';
import { MasterService } from 'src/app/master/master.service';
import { InsiderServiceService } from '../insider-service.service';

@Component({
  selector: 'app-insider-add',
  templateUrl: './insider-add.component.html',
  styleUrls: ['./insider-add.component.scss']
})
export class InsiderAddComponent implements OnInit {
  isLoading = false;
  button = 'Save';
  @ViewChild('userPhoto') userPhoto: ElementRef;
   attachName: any;
   public active1 = 1;
  insiderCreateForm: FormGroup;
  listProject: any;
  path: any;
  selectedOthers: any;
  accessSuccess: string;
  image: string;
  pathImage: any;
  othersSelectDic: boolean = false;
  othersSelectAccessUpsi: boolean  = false;
  othersSelectconnectPerson: boolean  = false;
  othersSelectFiduciary: boolean  = false;
  othersSelectInter: boolean  = false;
  othersInsiderNationSelect:boolean = false;
  companyDetailsSelect:boolean = false;
  d = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
    [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
    [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
    [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
    [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
    [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
    [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
    [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
    [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]
  ];
  
  p = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
    [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
    [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
    [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
    [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
    [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
    [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]
  ];
  constructor(private fb: FormBuilder, private insiderService:InsiderServiceService, private router:Router, private toastr: ToastrService, private masterService: MasterService) {
    this.accessSuccess = sessionStorage.getItem('access_success');
    if(this.accessSuccess !== '1'){
      this.router.navigate(['auth/login']);      
    }
   }
  submitted:boolean = false;
  attachmentPath:boolean = false;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  relationshipDropdown:any = []
  othersSelect:boolean = false;
  othersInsiderSelect:boolean = false;
  othersInsiderSelectCin:boolean = false;
   regex = "[A-Z]{5}[0-9]{4}[A-Z]{1}";
  ngOnInit(): void {
    this.insiderCreateForm = this.fb.group({
      // project: new FormControl ('', Validators.required),
      name: new FormControl ('',  [Validators.required,Validators.pattern('^[a-zA-Z0-9 _.,/()#&]+$')]),
      insiderType: new FormControl ('',  Validators.required),
      cin: new FormControl ('',Validators.pattern('^[a-zA-Z0-9 _.,/()#&]+$')),
      designation: new FormControl ('', Validators.pattern('^[a-zA-Z0-9 _.,/()#&]+$')),
      relationship_with_company: new FormControl ('',  Validators.required),
      realationship_with_connected_person: new FormControl (''),
      others : new FormControl('', Validators.pattern('^[a-zA-Z0-9 _.,/()#&]+$')),
      // otherdic: new FormControl (''),
      // othersintermediary:  new FormControl (''),
      // othersfiduciary:  new FormControl (''),
      // othersconnectedperson:  new FormControl (''),
      // othersaccesstoupsi:  new FormControl (''),
      email: new FormControl('',  [Validators.required,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-zA-Z/\| ]{2,}$')]),
      mobileNo: new FormControl ('', [Validators.required, Validators.pattern("^((\\+?)|0)?[0-9\ \-]+$")]),
      // phoneNo: ['',  Validators.required],
      panNo: new FormControl ('',  [Validators.required]),
      DocumentType : new FormControl ('',  [Validators.required]),
      fileName: new FormControl (''),
      filePath: new FormControl(''),
      image: new FormControl (''),  
      address: new FormControl ('',  [Validators.required, Validators.pattern('^[a-zA-Z\n0-9 _.,/()#&]+$')]),
      nationality: new FormControl (''),
      others_nationality: new FormControl('', Validators.pattern('^[a-zA-Z0-9 _.,/()#&]+$')),
      //designated_person:new FormControl ('No', Validators.required),
      // selectPersonNo:['', Validators.required],
      // access_sdd:['Yes', Validators.required],
      // access_project:['']
      confidentiality_agreement_entered: new FormControl ('No',  Validators.required),
      confidentiality_agreement_date: new FormControl (''),
      remarks: new FormControl('', Validators.pattern('^[a-zA-Z\n0-9 _.,/()#&]+$')),
      company_name: new FormControl ('',Validators.pattern('^[a-zA-Z0-9 _.,/()#&]+$')),  
      isinnumber: new FormControl ('',Validators.pattern('^[a-zA-Z0-9 _.,/()#&]+$')), 
      company_email: new FormControl('',[Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-zA-Z/\| ]{2,}$')]),
      company_pan: new FormControl(''),
      company_contact_no: new FormControl('',[Validators.pattern("^((\\+?)|0)?[0-9\ \-]+$")]),
      company_address: new FormControl('', Validators.pattern('^[a-zA-Z\n0-9 _.,/()#&]+$')),
      company_cin: new FormControl('', Validators.pattern('^[a-zA-Z0-9 _.,/()#&]+$'))
    });

    this.masterService.projectList(null).subscribe(
      res => {
      this.listProject = res.body['data']     
        },
        err => {
            console.log(err);
        }
    );
 
  //Multi select box
  // this.dropdownList = [
  //   // { id: 1, itemName: 'Project 1' },
  //   // { id: 2, itemName: 'Project 2' },
  //   // { id: 3, itemName: 'Project 3' },
  //   // { id: 4, itemName: 'Project 4' },
  //   // { id: 5, itemName: 'Project 5' }
  // ];
  this.selectedItems = [
    // { id: 2, itemName: 'Singapore' },
    // { id: 3, itemName: 'Australia' },
    // { id: 4, itemName: 'Canada' },
    // { id: 5, itemName: 'South Korea' }
  ];
  this.dropdownSettings = {
    singleSelection: false,
    text: 'Select the Project Name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: 'myclass custom-class'
  };
  
  //Multi select box
//Relationship with Company
this.relationshipDropdown = [
  //{ listItem: 'AMC of mutual fund'  },
  { listItem: 'Asset Management Company'  },
  { listItem: 'Associate Company' },
  { listItem: 'Auditor'  },
  { listItem: 'Statutory Auditor'  },
  { listItem: 'Internal Auditor'  },
  { listItem: 'Cost Auditor'  },
  { listItem: 'Secretarial Auditor'  },
  { listItem: 'Banker'  },
  { listItem: 'Clearing House'  },
  { listItem: 'Director and their immediate relatives'},
  { listItem: 'Director of insider of Mutual fund'  },
  { listItem: 'Employee'  },
  { listItem: 'Director of AMC with indirect 10%+ investment'},
  { listItem: 'Holding Company' },
  { listItem: 'Relative of Connected Person' },
  { listItem: 'Investment Company'  },
  { listItem: 'KMP and their immediate relatives'  },
  { listItem: 'Legal Firm ' },
  { listItem: 'Liquidator'  },
  { listItem: 'Mutual Fund'  },
  { listItem: 'Official of Stock Exchange'  },
  { listItem: 'Other Connected Person'  },
  { listItem: 'Other Fiduciary'  },
  { listItem: 'Other Intermediary'  },
  { listItem: 'Other Person with access to UPSI' } ,
  { listItem: 'Promoter/immediate relatives'  },  
  { listItem: 'Public Financial Institution'  },
  { listItem: 'Resigned Employee'  },
  { listItem: 'Stock Broker'  },  
  { listItem: 'Subsidiary Company'  },   
  { listItem: 'Trustee Company'  } , 
  { listItem: 'Firm, partner, employee of connected person'  } ,
  { listItem: 'Common household, residence'  }  
  
  ]
// this.relationshipDropdown = [
//   { listItem: 'AMC of mutual fund'  },
//   { listItem: 'Asset Management Company'  },
//   { listItem: 'Associate Company' },
//   { listItem: 'Auditor'  },
//   { listItem: 'Statutory Auditor'  },
//   { listItem: 'Internal Auditor'  },
//   { listItem: 'Cost Auditor'  },
//   { listItem: 'Secretarial Auditor'  },
//   { listItem: 'Banker'  },
//   { listItem: 'Clearing House'  },
//   { listItem: 'Director'},
//   { listItem: 'Director of insider company'  },
//   { listItem: 'Employee'  },
//   { listItem: 'Entity with 10%+ investment from director'},
//   { listItem: 'Holding Company' },
//   { listItem: 'Immediate Relative of Connected Person' },
//   { listItem: 'Investment Company'  },
//   { listItem: 'KMP'  },
//   { listItem: 'Legal Firm ' },
//   { listItem: 'Liquidator'  },
//   { listItem: 'Mutual Fund'  },
//   { listItem: 'Official of Stock Exchange'  },
//   { listItem: 'Other Connected Person'  },
//   { listItem: 'Other Fiduciary'  },
//   { listItem: 'Other Intermediary'  },
//   { listItem: 'Other Person with access to UPSI' } ,
//   { listItem: 'Promoter'  },  
//   { listItem: 'Public Financial Institution'  },
//   { listItem: 'Stock Broker'  },  
//   { listItem: 'Subsidiary Company'  },   
//   { listItem: 'Trustee Company'  }  
//   ]
 
  }
  base64Output : string;

  filePath(){
    if(this.insiderCreateForm.get('fileName')?.value != ''){
    this.attachName = this.insiderCreateForm.get('fileName')?.value;
    
    // this.path =  this.attachName.split("\\").pop();
    this.path =  this.attachName[0].name;
  
    // const Path = this.insiderCreateForm.get('filePath').value;
    // Path.push(this.path)
   
    }
    this.attachmentPath = true;
  }
  removeFile(){
    this.userPhoto.nativeElement.value = "";

    this.insiderCreateForm.get('fileName')?.setValue("");
    this.path = "";
    // this.attachName = "";
    // this.userPhoto.nativeElement.value = null;
    this.attachmentPath = false;
    
  }
  changeListener($event) : void {   
    this.readThis($event?.target);
    this.filePath()
  //  this.insiderCreateForm.get('fileName')?.setValue(File);
  }

  readThis(inputValue: any): void {
    var file:File = inputValue.files[0];
   
    var myReader:FileReader = new FileReader();
    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      this.image = btoa(myReader.result.toString());   
      this.insiderCreateForm.value.image=myReader.result;
      this.pathImage = this.insiderCreateForm.value.image;
    }
  }
  onFileSelected(event) {
    this.filePath()
      this.convertFile(event.target.files[0]).subscribe(base64 => {
      this.base64Output = base64;     
    });
  }

  convertFile(file : File) : Observable<string> {
    this.filePath()
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    // reader.onload = (event) => result.next(btoa(event.target.result.toString()));
    reader.onload = (event) => result.next(event.target.result.toString());
    return result;
  }

  //Individual
  insiderTypeChanged() {
    let selectedOthers:any = this.insiderCreateForm.get('insiderType');
    let insidertypename =  selectedOthers.value;
    if(selectedOthers?.value == "Individual"){
      this.othersInsiderSelect = true;
      this.othersInsiderSelectCin = false;
      this.insiderCreateForm.get('cin')?.setValue("");
    }else if(selectedOthers?.value == "Company"){
      this.othersInsiderSelectCin = true;
      this.othersInsiderSelect = false;
      this.insiderCreateForm.get('designation')?.setValue("");
      this.insiderCreateForm.get('nationality')?.setValue("");
    }else if(selectedOthers?.value == "LLP"){
      this.othersInsiderSelectCin = true;
      this.othersInsiderSelect = false;
      this.insiderCreateForm.get('designation')?.setValue("");
      this.insiderCreateForm.get('nationality')?.setValue("");
    }else{
      this.othersInsiderSelectCin = false;
      this.othersInsiderSelect = false;
      this.insiderCreateForm.get('designation')?.setValue("");
      this.insiderCreateForm.get('nationality')?.setValue("");
      this.insiderCreateForm.get('cin')?.setValue("");
    }
    this.relationshipPersonChanged(insidertypename)
  }
    // nationality
    insiderNationalityChanged() {
      let selectedOthers = this.insiderCreateForm.get('nationality')    
      if(selectedOthers?.value == "Others"){
        this.othersInsiderNationSelect = true;
        }else{
          this.othersInsiderNationSelect = false;
          this.insiderCreateForm.get('others_nationality')?.setValue("");

      }
    }
  //Cin Number
  insiderTypeChangedCin() {
    this.selectedOthers = this.insiderCreateForm.get('insiderType')    
   
  }
  
  relationshipPersonChanged(e) {
    let insiderType = this.insiderCreateForm.get('insiderType');
    this.selectedOthers = this.insiderCreateForm.get('relationship_with_company')
    if((insiderType?.value == "Individual" && (this.selectedOthers?.value == "Associate Company" || this.selectedOthers?.value == "Auditor" 
    || this.selectedOthers?.value == "Statutory Auditor" || this.selectedOthers?.value == "Internal Auditor" || this.selectedOthers?.value == "Cost Auditor" || this.selectedOthers?.value == "Secretarial Auditor" || this.selectedOthers?.value == "Banker"))){
      this.companyDetailsSelect = true;
    }else{
      this.companyDetailsSelect = false;
      this.insiderCreateForm.get('company_name')?.setValue('');
      this.insiderCreateForm.get('company_email')?.setValue('');
      this.insiderCreateForm.get('isinnumber')?.setValue('');
      this.insiderCreateForm.get('company_pan')?.setValue('');
      this.insiderCreateForm.get('company_contact_no')?.setValue('');
      this.insiderCreateForm.get('company_address')?.setValue('');
    }
    if(this.selectedOthers?.value == "Relative of Connected Person"){
      this.othersSelect = true;
    }else{
      this.othersSelect = false;
      this.insiderCreateForm.get('realationship_with_connected_person')?.setValue('');

    }
    //Director of insider company
    if(this.selectedOthers?.value == "Director of insider of Mutual fund" ||this.selectedOthers?.value == "Other Intermediary" 
 || this.selectedOthers?.value == "Other Fiduciary" || this.selectedOthers?.value == "Other Connected Person" ||
 this.selectedOthers?.value == "Other Person with access to UPSI"){
      this.othersSelectDic = true;
    }else{
      this.othersSelectDic = false;
      this.insiderCreateForm.get('others')?.setValue('');

    }
      //Other Intermediary
      // if(this.selectedOthers?.value == "Other Intermediary"){
      //   this.othersSelectInter = true;
      // }else{
      //   this.othersSelectInter = false;
      // }
        //Other Fiduciary
    // if(this.selectedOthers?.value == "Other Fiduciary"){
    //   this.othersSelectFiduciary = true;
    // }else{
    //   this.othersSelectFiduciary = false;
    // }
      //Other Connected Person
      // if(this.selectedOthers?.value == "Other Connected Person"){
      //   this.othersSelectconnectPerson = true;
      // }else{
      //   this.othersSelectconnectPerson = false;
      // }
        //Other Person with access to UPSI
    // if(this.selectedOthers?.value == "Other Person with access to UPSI"){
    //   this.othersSelectAccessUpsi = true;
    // }else{
    //   this.othersSelectAccessUpsi = false;
    // }
  }
  // insiderTypeChangedLlp() {
  //   this.selectedOthers = this.insiderCreateForm.get('insiderType')    
  //   if(this.selectedOthers?.value == "Company"){
  //     this.othersInsiderSelectCin = true;
  //   }else{
  //     this.othersInsiderSelectCin = false;
  //   }
  // }
  cancelInsider(){
    this.router.navigate(['/insider/insider-list']);
    this.insiderCreateForm.reset();
  }
//Multi select box
onItemSelect(item: any) {
  console.log(item);
  console.log(this.selectedItems);
}
OnItemDeSelect(item: any) {
  console.log(item);
  console.log(this.selectedItems);
}
onSelectAll(items: any) {
  console.log(items);
}
onDeSelectAll(items: any) {
  console.log(items);
}
//multi select box
    //select radio button
 selectedButton: string="No";        

 radioSelect(e: string): void {
     this.selectedButton = e; 
     if(this.selectedButton !== "Yes"){
      this.insiderCreateForm.get('fileName')?.setValue("");
      this.insiderCreateForm.get('confidentiality_agreement_date')?.setValue("");
      this.insiderCreateForm.get('filePath')?.setValue("");
      this.attachmentPath = false;
    }
 }  
 
 isSelected(name: string): boolean {  
 
     if (!this.selectedButton) {   
         return false;  
     }    
 
     return (this.selectedButton === name); 
 } 
 onBlur(): void {
  console.log('Focus Is Lost for this Element');
}
//AAdharValidation
validate(addharNumber) {
  let c = 0;
  let invertedArray = addharNumber
    .split('')
    .map(Number)
    .reverse();

  invertedArray.forEach((val, i) => {
    c = this.d[c][this.p[i % 8][val]];
  });

  return c === 0;
}
    onSubmit(){
      let idendiferCard = this.insiderCreateForm.get('panNo')?.value;
      if(this.insiderCreateForm.get('DocumentType')?.value == 'PAN'){
        
        let regex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
        if (!regex.test(idendiferCard)) {
          this.toastr.warning("Please Enter the Valid PAN.");
         // this.messageValid = 'Please Enter the Valid PAN.';
         return false;
        }
      }else if(this.insiderCreateForm.get('DocumentType')?.value == 'Aadhar card'){
        
        let regex = new RegExp(/^[A-Z]{0}[0-9]{12}[A-Z]{0}$/);
        if(!regex.test(idendiferCard)){
          this.toastr.warning('Please Enter Valid Aadhar Number');
          return false;
        }else{
        if (this.validate(idendiferCard) && idendiferCard) {         
          
        } else {
          this.toastr.warning('Your Aadhar Number is InValid')
          return false;      
        }
      }

      }else if(this.insiderCreateForm.get('DocumentType')?.value == 'Voter ID'){
        let regex = new RegExp(/^([a-zA-Z]){3}([0-9]){7}?$/);
        if(!regex.test(idendiferCard)){
          this.toastr.warning('Please Enter Valid Voter ID');
          return false;
        }
    }else if(this.insiderCreateForm.get('DocumentType')?.value == 'Driving License'){
      let regex = new RegExp(/^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/);
        if(!regex.test(idendiferCard)){
          this.toastr.warning('Please Enter Valid Driving License');
          return false;
        }
    }
    if(this.insiderCreateForm.get('confidentiality_agreement_entered')?.value == 'Yes'){
      if(this.insiderCreateForm.get('confidentiality_agreement_date')?.value == null || this.insiderCreateForm.get('confidentiality_agreement_date')?.value == ''){
        this.toastr.warning('Please Enter the Confidentiality Agreement Date');
        return false;
      }
    }
    let insiderType = this.insiderCreateForm.get('insiderType');
    let selectedOthers = this.insiderCreateForm.get('relationship_with_company')
    if(insiderType?.value == "Individual"){
      if(this.insiderCreateForm.get('designation')?.value == ''){
        this.toastr.warning('Please Enter the Designation');
        return false;
      }else if(this.insiderCreateForm.get('nationality')?.value == ''){
        this.toastr.warning('Please Enter the Nationality');
        return false;
      }
    }else if(insiderType?.value == "Company" || insiderType?.value == "LLP"){
      if(this.insiderCreateForm.get('cin')?.value == ''){
        this.toastr.warning('Please Enter the CIN Number');
        return false;
      }
    }

    if((insiderType?.value == "Individual" && (selectedOthers?.value == "Associate Company" || selectedOthers?.value == "Auditor"   || selectedOthers?.value == "Statutory Auditor" || 
    selectedOthers?.value == "Internal Auditor" || selectedOthers?.value == "Cost Auditor" || selectedOthers?.value == "Secretarial Auditor" || selectedOthers?.value == "Banker"))){
      let panCardNo = this.insiderCreateForm.get('company_pan')?.value;    
      if(this.insiderCreateForm.get('company_name')?.value == ''){
        this.toastr.warning("Please fill the Entity Name.");
        return false;
      }else if(this.insiderCreateForm.get('company_email')?.value == ''){
        this.toastr.warning("Please fill the Entity Email ID.");
        return false;
      }else if(this.insiderCreateForm.get('company_pan')?.value == ''){
        this.toastr.warning("Please fill the Entity PAN No.");
        return false;
      }else if(this.insiderCreateForm.get('company_contact_no')?.value == ''){
        this.toastr.warning("Please fill the Entity Contact Number.");
        return false;
      }else if(this.insiderCreateForm.get('company_address')?.value == ''){
        this.toastr.warning("Please fill the Entity Address.");
        return false;
      }
      if(panCardNo != ''){
        let regex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
          if (!regex.test(panCardNo)) {
            this.toastr.warning("Please Enter the Valid Company PAN.");
           return false;
          }
        }
    }
      this.submitted = true;
      const emptyFileds = Object.keys(this.insiderCreateForm.controls).filter(key =>this.insiderCreateForm.controls[key].errors !== null)

     if(this.insiderCreateForm.status !== 'INVALID'){
      this.isLoading = true;
      this.button = 'Processing';
        this.insiderService.addinsider(this.insiderCreateForm.value).subscribe(data =>{
          
         if(data.success == '1'){
            this.toastr.success("Insider Successfully created");
            this.isLoading = false;
            this.button = 'Save';
            this.router.navigate(['/insider/insider-list']);
          }else{
            this.toastr.warning(data?.message);
            this.isLoading = false;
            this.button = 'Save';
          }
        })
      }else if(emptyFileds.length > 1){
        this.toastr.warning("Please fill all Mandatory fields.");
        return false;
      } else{
        if(this.insiderCreateForm.get('name')?.value == ''){
          this.toastr.warning("Please fill the Name of Insider.");
        }
        else if(this.insiderCreateForm.get('insiderType')?.value == ''){
          this.toastr.warning("Please fill the Insider Type.");
        }
        else if(this.insiderCreateForm.get('relationship_with_company')?.value == ''){
          this.toastr.warning("Please fill the Relationship with Company.");
        }
        else if(this.insiderCreateForm.get('email')?.value == ''){
          this.toastr.warning("Please fill the Email ID.");
        }
        else if(this.insiderCreateForm.get('mobileNo')?.value == ''){
          this.toastr.warning("Please fill the Contact Number.");
        }
        else if(this.insiderCreateForm.get('DocumentType')?.value == ''){
          this.toastr.warning("Please fill the ID Proof Type.");
        }
        else if(this.insiderCreateForm.get('panNo')?.value == ''){
          this.toastr.warning("Please fill the ID Proof No.");
        }
        else if(this.insiderCreateForm.get('address')?.value == ''){
          this.toastr.warning("Please fill the Address.");
        }
                
      }
           
    }
}
